import { MockHook } from '@jupiterone/jupiter-web-toolkit';
export interface DeletePermissionDialogProps {
  title: string;
  onCancel: () => void;
  onDelete: (permission: any) => void;
  saving: boolean;
}
const useDeletePermissionDialogLogic = ({
  title,
  onCancel,
  onDelete,
  saving,
}: DeletePermissionDialogProps) => {
  return {
    title,
    handleCancel: onCancel,
    handleDelete: onDelete,
    saving,
  };
};

export type DeletePermissionDialogComponentProps = ReturnType<
  typeof useDeletePermissionDialogLogic
>;
export const MOCK_DELETE_PERMISSION_DIALOG_PROPS: DeletePermissionDialogComponentProps = {
  title: 'Delete permission set #1',
  handleCancel: MockHook.mockFunction,
  handleDelete: MockHook.mockFunction,
  saving: false,
};
export default MockHook.useMockHook(
  useDeletePermissionDialogLogic,
  MOCK_DELETE_PERMISSION_DIALOG_PROPS
);
